import { WorkstreamDefinitionOperationConfigGridRow } from '@/pages/OperationsAdministration/types/WorkstreamDefinitionOperationConfigGridRow';

import { WorkstreamDefinitionOperationConfigPatchSchema } from '@/pages/OperationsAdministration/types/Api/WorkstreamDefinitionOperationConfigPatch';

export function tfRowToWorkstreamConfigPatch(row: WorkstreamDefinitionOperationConfigGridRow) {
    return WorkstreamDefinitionOperationConfigPatchSchema.parse({
        // TODO: add backlogEffectiveFrom when we have a way to update it
        // backlogEffectiveFrom: row.backlogEffectiveFrom,
        advancedSnapshot: { isEnabled: row.state === 'enabled' }
    });
}